import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import valuer_api from "../../api/valuer";
import date_formatter from "../../utils/DateUtils";
import admin_api from "../../api/admin/admin_valuer";
import search_logo from "../../assets/profile_search.png";
import ValuationStatusPill from "../ValuationStatusPill";
import PageNavigation from "../PageNavigation";

const RICSHubRequestsGrid = (props) => {
    const status = props.status;
    const navigate = useNavigate();
    const [propertySearchString, setPropertySearchString] = useState();
    const [reports, setReports] = useState();
    const [states, setStates] = useState();
    const [dataLoaded, setDataLoaded] = useState(false);
    const PAGE_SIZE = 6
    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState()

    const getReports = () => {
        const body = {
            "search": propertySearchString,
            "page": page,
            "page_size": PAGE_SIZE,
            "status": status
        }
        let response = admin_api.getValuerReports(body);
        response.then(response => {
            for (let i=0;i<response.data.reports.length;i++){
                response.data.reports[i].remaining_time = setFormattedRemainingTime(response.data.reports[i].request_date);
                response.data.reports[i].status_name = getStateName(response.data.reports[i].current_status_id);
            }
            setReports(response.data.reports);
            setMaxPage(response.data.total_pages);
            setDataLoaded(true);
        }).catch(err => {
            console.log(err);
        })
    }

    const getStates = () => {
        let response = valuer_api.getStatuses()
        response.then(
            response => {
                let list = [{"id":6,"name":"New"}];
                list.push(...response.data.statuses);
                setStates(list);
            }
        ).catch(err => {
            console.log(err);
        })
    }

    const setFormattedRemainingTime = (tm) => {
        if (!tm) return "";
        let result = "";
        const day = 60*60*24*1000;
        let today = new Date();
        const day_ago = (today.getTime() - day);
        let diff = (tm * 1000) - day_ago;
        if (diff < 0)
            result = "EXPIRED";
        else
            result = date_formatter.date_display_diff(diff);
        return result;
    }

    const updateRemainingTime = () => {
        if (!reports) return;
        let updatedReports = [...reports];
        for (let i=0;i<reports.length;i++){
            updatedReports[i].remaining_time = setFormattedRemainingTime(reports[i].request_date);
        }
        setReports(updatedReports);
    }

    const getStateName = (id) => {
        if (!states) return;
        let state = states.find((s) => s.id === parseInt(id));

        return state.name;
    }

    const nextPage = (ev) => {
        if (!page || !ev || page === maxPage) return;
        setPage(page+1);
    }

    const previousPage = (ev) => {
        if (!page || !ev || page === 1) return;
        setPage(page-1);
    }

    const numberPageClick = (page_number) => {
        if (!page_number) return;
        setPage(page_number);
    }

    useEffect(() => {
        getStates()
    }, [])

    useEffect(() => {
        if (!states) return;
        getReports()
    }, [states])

    useEffect(() => {
        // The interval must be set against the data load state variable as the "reports" state variable
        // is never defined if the interval is created in the main useEffect
        let interval = setInterval(() => {updateRemainingTime()}, 60000);
        return (() => {
            clearInterval(interval);
        })
    }, [dataLoaded])

    useEffect(() => {
        getReports()
    }, [propertySearchString, page])

    return (
        <>
            <div className="valuer-report-grid-container">
                <div className="valuer-report-grid-header-container">
                    <div className="report-detail-search-container">
                        <input type="text" placeholder="Search for property" value={propertySearchString}
                               onChange={(ev) => setPropertySearchString(ev.target.value)}/>
                        <div className="link">
                            <img src={search_logo} id="search-icon"/>
                        </div>
                    </div>
                </div>
                <div className="valuer-report-grid">
                    <div className="valuer-report-grid-col-headers">
                        <div className="address col">Property address</div>
                        <div className="postcode col">Postcode</div>
                        <div className="date col">Date and time</div>
                        <div className="remaining col">Time remaining</div>
                        <div className="ticket col">Ticket</div>
                        <div className="valuer col">Assignee</div>
                        <div className="status col">Status</div>
                    </div>
                    <div className="valuer-report-grid-rows">
                        {reports && reports.map((report, idx) => {
                            return (
                                <>
                                    <div className="valuer-report-grid-row">
                                        <div className="address col" id={idx}>{report.address}</div>
                                        <div className="postcode col" id={idx}>{report.postcode}</div>
                                        <div className="date col" id={idx}>{date_formatter.display_date_time(report.request_date*1000)}</div>
                                        <div className="remaining col" id={idx}>{report.remaining_time}</div>
                                        <div className="ticket col" id={idx}>
                                            {report.status_name}
                                        </div>
                                        <div className="ticket col" id={idx}>{report.valuer.firstname ? report.valuer.firstname.substring(0,1) : "?"}. {report.valuer.lastname}</div>
                                        <div className="status col">
                                            <ValuationStatusPill status_id={report.summary_status_id}
                                                                 status_name={report.summary_status_name}/>
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                    </div>
                    <div className="report-detail-page-navigation-container">
                        <PageNavigation page={page}
                                        maxPage={maxPage}
                                        previousPage={previousPage.bind(this)}
                                        numberPageClick={numberPageClick.bind(this)}
                                        nextPage={nextPage.bind(this)}/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RICSHubRequestsGrid